export function buildFilterParam(filter?: any): string {
  if (!filter) return '';
  try {
    const payload = typeof filter === 'string' ? filter : JSON.stringify(filter);
    return payload ? `?filter=${encodeURIComponent(payload)}` : '';
  } catch (_e) {
    return '';
  }
}

